import FingerprintJS from '@fingerprintjs/fingerprintjs'

export const generateFingerprint = async () => {
  const fpPromise = FingerprintJS.load({ monitoring: false })

  try {
    const fpjs = await fpPromise
    const result = await fpjs.get()

    return result.visitorId
  } catch (error) {
    return null
  }
}
